import React from 'react';
import { MachineTranslationMixin } from './machine_translation_mixin';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const TranslationEditInterface = createReactClass({
  getInitialState() {
    const sourceTranslation = this.props.translations.filter(function(translation) {
      return translation.is_source;
    })[0];

    const sortedTranslations = this.sortTranslations(this.props.translations);
    return {
      translations: sortedTranslations,
      selectedTable: this.props.table,
      selectedColumnName: this.props.columnName,
      selectedRowId: this.props.rowId,
      sourceTranslation,
      saveInProgress: false,
      showNewTranslationForm: false,
      sourceEntry: this.props.sourceEntry
    };
  },
  localeCodeToLanguageName(localeCode) {
    return this.props.acceptedLanguages[MachineTranslationMixin.localeCodetoISO(localeCode)].name;
  },
  sortTranslations(translations) {
    const sortedTranslations = translations.sort((a, b) => {
      return this.localeCodeToLanguageName(a.language) > this.localeCodeToLanguageName(b.language) ? 1 : -1;
    });

    return this.appendBlankLanguagesToTranslationsList(sortedTranslations);
  },
  findLocalizationFromInputs() {
    const newTableName = this.refs.table.value;
    const newColumnName = this.refs.column.value;
    const newRowId = this.refs.rowId.value;
    // only search if localization will be different
    if (newTableName == this.state.selectedTable && newColumnName == this.state.selectedColumnName && newRowId == this.state.selectedRowId) {
      return;
    }

    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/localizations',
      { table: newTableName, columnName: newColumnName, rowId: newRowId },
      localizations => {
        if (localizations && localizations.length > 0) {
          const entrySourceHash = localizations[localizations.length - 1];
          let newSourceEntry = '';
          if (entrySourceHash.sourceEntry) {
            newSourceEntry = entrySourceHash.content;
            localizations.pop();
          }

          const sourceTranslation = localizations.slice().filter(function(translation) {
            return translation.is_source;
          })[0];

          const sortedTranslations = localizations.sort(
            function(a, b) {
              return this.localeCodeToLanguageName(a.language) > this.localeCodeToLanguageName(b.language) ? 1 : -1;
            }.bind(this)
          );

          this.setState(
            {
              translations: sortedTranslations,
              selectedTable: newTableName,
              selectedColumnName: newColumnName,
              selectedRowId: newRowId,
              sourceTranslation,
              sourceEntry: newSourceEntry
            },
            () => {
              this.setState({ translations: this.appendBlankLanguagesToTranslationsList(this.state.translations) });
            }
          );
        }
      },
      err => {
        if (err && err.status == 404) {
          this.setState({
            translations: [],
            sourceEntry: null,
            selectedTable: newTableName,
            selectedColumnName: newColumnName,
            selectedRowId: newRowId,
            sourceTranslation: null
          });
        } else {
          console.error('Error occurred', err);
        }
      },
      () => {}
    );
  },
  appendBlankLanguagesToTranslationsList(sortedTranslations) {
    // create blank boxes for languages that we usually have but do not exist for this localization set
    const missingLanguageEntries = ['en-US', 'es-ES', 'fr-FR', 'de-DE'];
    for (let i = 0; i < sortedTranslations.length; i++) {
      const index = missingLanguageEntries.indexOf(sortedTranslations[i].language);
      if (index > -1) {
        missingLanguageEntries.splice(index, 1);
      }
    }
    const blankBoxLanguages = missingLanguageEntries.map(i => {
      return { language: i };
    });
    sortedTranslations = sortedTranslations.concat(blankBoxLanguages);
    return sortedTranslations;
  },
  performSaveAll(retranslateOption) {
    // save new one if we have one
    if (this.state.showNewTranslationForm) {
      this.handleCreateNewLocalizationClick();
    }

    const updateBody = {
      translations: this.state.translations,
      retranslate: retranslateOption,
      rowId: this.state.selectedRowId,
      table: this.state.selectedTable,
      columnName: this.state.selectedColumnName
    };
    this.setState({ saveInProgress: true });
    ServerCommunicationUtil.putApiEndpoint(
      '/api/alltrails/localizations/1',
      updateBody,
      data => {
        const currUrl = `/edit-translations?table=${this.state.selectedTable}&column_name=${this.state.selectedColumnName}&id=${this.state.selectedRowId}`;
        if (currUrl === window.location.href) {
          window.location.reload();
        } else {
          window.location.href = currUrl;
        }
      },
      err => {
        console.error('Error occurred', err);
      },
      data => {
        this.setState({ saveInProgress: false });
      }
    );
  },
  handleSaveClick() {
    this.performSaveAll(false);
  },
  handleSaveAndReTransClick() {
    this.performSaveAll(true);
  },
  handleToggleCreateRowClick(e) {
    this.setState({ showNewTranslationForm: !this.state.showNewTranslationForm });
  },
  handleChangeSource(index, e) {
    if (this.state.translations[index].is_source) {
      return;
    }
    const currentTranslations = this.state.translations;
    let newSourceTranslation;
    for (let i = 0; i < currentTranslations.length; i++) {
      if (i == index) {
        currentTranslations[i].is_source = true;
        newSourceTranslation = currentTranslations[i];
      } else {
        currentTranslations[i].is_source = false;
      }
    }
    this.setState({ translations: currentTranslations, sourceTranslation: newSourceTranslation });
  },
  handleTextAreaKeyUp(index, e) {
    // maintain any changes, consider a translation to be done by a human if they explicitly entered text
    const translations = [...this.state.translations];
    translations[index].content = e.target.value;
    translations[index].translated_by = 'HU';
    this.setState({ translations });
  },
  handleLanguageSelectChange(index, e) {
    const translations = [...this.state.translations];
    translations[index].language = e.target.value;
    translations[index].translated_by = 'HU';
    this.setState({ translations });
  },
  handleDeleteClick(i, targetLanguage) {
    if (this.state.translations[i].is_source) {
      const msg = `Are you sure you wish to delete the source string? This will also clear ${this.state.selectedColumnName} in the ${this.state.selectedTable} record.`;
      if (!confirm(msg)) {
        return false;
      }
    }
    const localizationId = this.state.translations[i].id;
    ServerCommunicationUtil.deleteApiEndpoint(
      `/api/alltrails/localizations/${localizationId}`,
      {},
      data => {
        let translations = this.state.translations.filter((translation, idx) => {
          return translation.id !== localizationId;
        });
        translations = this.sortTranslations(translations);
        this.setState({ translations });
      },
      () => {},
      () => {}
    );
  },
  changeTableSelection(e) {
    this.setState({ selectedTable: e.target.value });
  },
  handleRetranslateClick(i, targetLanguage) {
    const targetText = this.refs[`content-${this.state.sourceTranslation.language}`].value;
    // need to change state and force text areas to pick up new content
    MachineTranslationMixin.translateString(
      targetText,
      targetLanguage,
      function(translatedString) {
        const currentTranslations = this.state.translations;
        const changedTranslation = currentTranslations[i];
        changedTranslation.content = translatedString;
        changedTranslation.translated_by = 'GT';
        this.setState({ translations: currentTranslations });
      }.bind(this),
      this.state.sourceTranslation.language
    );
  },
  saveNewLocalization(targetLang, targetText) {
    const newTranslationBody = {
      code: targetLang,
      content: targetText.trim(),
      rowId: this.state.selectedRowId,
      table: this.state.selectedTable,
      columnName: this.state.selectedColumnName
    };

    this.setState({ saveInProgress: true });
    ServerCommunicationUtil.postApiEndpoint(
      '/api/alltrails/localizations',
      { new_translation: newTranslationBody },
      localizations => {
        if (localizations) {
          const currentTranslations = this.state.translations;
          currentTranslations.push(localizations[0]);
          this.setState({ translations: currentTranslations, showNewTranslationForm: false });
        }
      },
      err => {
        console.error('Error occurred', err);
        const resp = JSON.parse(err.responseText);
        if (resp && resp.errors && resp.errors[0].code == 'invalid_param') {
          alert(`Translation already exists for ${this.props.acceptedLanguages[targetLang].name}`);
        }
      },
      data => {
        this.setState({ saveInProgress: false });
      }
    );
  },
  handleCreateNewLocalizationClick() {
    let targetText = this.refs['new-translation-content'].value;
    const targetLang = this.refs['new-translation-langcode'].value;
    let translatePromise = null;

    if (this.state.sourceTranslation && (targetText == '' || targetLang == '')) {
      if (confirm('Missing text for new translation.  Do you want to generate one from the source language?')) {
        const targetTextForNewTranslation = this.refs[`content-${this.state.sourceTranslation.language}`].value;
        const transFunc = MachineTranslationMixin.translateString;
        translatePromise = new Promise(function(resolve, reject) {
          transFunc(targetTextForNewTranslation, targetLang, function(translatedString) {
            targetText = translatedString;
            resolve(translatedString);
          });
        });
      }
    }
    if (translatePromise != null) {
      translatePromise.then(
        function(str) {
          this.saveNewLocalization(targetLang, targetText);
        }.bind(this)
      );
    } else {
      this.saveNewLocalization(targetLang, targetText);
    }
  },
  renderSearchSelections() {
    const tableToColumnHash = {
      trails: ['name', 'description', 'tips', 'getting_there', 'parking_facilities', 'contact_info', 'alerts'],
      areas: ['name', 'overview', 'description'],
      lists: ['title', 'description'],
      states: ['name', 'overview', 'description'],
      cities: ['name', 'overview', 'description'],
      countries: ['name', 'overview', 'description'],
      at_map_markers: ['name', 'description'],
      at_maps: ['name', 'description'],
      trail_reviews: ['comment'],
      at_attributes: ['name'],
      users: ['about_me'],
      banners: ['message']
    };

    let columnOpts = [];
    if (this.state.selectedTable) {
      columnOpts = tableToColumnHash[this.state.selectedTable].map((item, index) => {
        return (
          <option key={this.state.selectedTable + index} value={item}>
            {item}
          </option>
        );
      });
    }

    let tableOptions = [
      <option key="notable" value={-1}>
        - Select a table -
      </option>
    ];
    tableOptions = tableOptions.concat(
      Object.keys(tableToColumnHash).map((item, index) => {
        return (
          <option key={item + index} value={item}>
            {item}
          </option>
        );
      })
    );

    return (
      <div className="localization-search-bar">
        <select ref="table" defaultValue={this.state.selectedTable} onChange={this.changeTableSelection}>
          {tableOptions}
        </select>
        <select ref="column" defaultValue={this.state.selectedColumnName}>
          {columnOpts}
        </select>
        <input ref="rowId" defaultValue={this.state.selectedRowId} />
        <span className="btn btn-slim blue rounded form-top" onClick={this.findLocalizationFromInputs}>
          Find
        </span>
      </div>
    );
  },
  translatedByHash: {
    GT: 'Google MT',
    DL: 'DeepL',
    HU: 'Human',
    SL: 'Smartling',
    MB: 'Mapbox'
  },
  renderTableOrg(sortedTranslations) {
    return (
      <table className="lifeline-history">
        <thead>
          <tr>
            <th>Language</th>
            <th>Source</th>
            <th>Translated By</th>
            <th>Content</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedTranslations.map(this.renderTranslationTableRow)}
          {this.state.showNewTranslationForm && this.renderNewTranslationForm()}
        </tbody>
      </table>
    );
  },
  renderButtonContainer() {
    if (this.state.translations.length > 0) {
      return (
        <div className="user-info-centered">
          <div className="btn green rounded simple" onClick={this.handleSaveClick}>
            {this.state.saveInProgress ? 'Saving...' : 'Save'}
          </div>
          <div className="btn blue rounded simple" onClick={this.handleSaveAndReTransClick}>
            {this.state.saveInProgress ? 'Saving...' : 'Save and Retranslate All'}
          </div>
          <div className="btn orange rounded simple" onClick={this.handleToggleCreateRowClick}>
            {this.state.showNewTranslationForm ? 'Cancel' : 'Create New Translation'}
          </div>
        </div>
      );
    }
    return (
      <div className="user-info-centered">
        <div className="btn orange rounded simple" onClick={this.handleToggleCreateRowClick}>
          {this.state.showNewTranslationForm ? 'Cancel' : 'Create New Translation'}
        </div>
      </div>
    );
  },
  renderNewTranslationForm() {
    let languageOptions = [<option value="-1">- Choose Language -</option>];
    languageOptions = languageOptions.concat(
      Object.keys(this.props.acceptedLanguages).map(
        function(key) {
          const item = this.props.acceptedLanguages[key];
          return <option value={item.code}>{item.name}</option>;
        }.bind(this)
      )
    );

    return (
      <tr>
        <td>
          <select ref="new-translation-langcode">{languageOptions}</select>
        </td>
        <td />
        <td />
        <td>
          <textarea ref="new-translation-content" defaultValue="" />
        </td>
        <td>
          <span className="btn btn-slim blue rounded" onClick={this.handleCreateNewLocalizationClick}>
            Save
          </span>
        </td>
      </tr>
    );
  },
  renderOriginalTextDisplay() {
    if (this.state.sourceEntry) {
      return (
        <div>
          <h3>Original Text</h3>
          <p>{this.state.sourceEntry}</p>
        </div>
      );
    }
    return null;
  },
  renderTranslationTableRow(currTranslation, i) {
    const languageOptions = Object.keys(this.props.acceptedLanguages).map(
      function(key) {
        const item = this.props.acceptedLanguages[key];
        return <option value={item.code}>{item.name}</option>;
      }.bind(this)
    );
    return (
      <tr key={currTranslation.language}>
        <td>
          <select
            ref={`translation-langcode-${i}`}
            value={MachineTranslationMixin.localeCodetoISO(currTranslation.language)}
            onChange={this.handleLanguageSelectChange.bind(this, i)}
          >
            {languageOptions}
          </select>
        </td>
        <td>
          <input type="checkbox" checked={currTranslation.is_source} onChange={this.handleChangeSource.bind(this, i)} />
        </td>
        <td>{this.translatedByHash[currTranslation.translated_by]}</td>
        <td>
          <textarea
            id={`content-${currTranslation.language}`}
            ref={`content-${currTranslation.language}`}
            value={currTranslation.content ? currTranslation.content : ''}
            onChange={this.handleTextAreaKeyUp.bind(this, i)}
          />
        </td>
        <td>
          <span className="btn btn-slim blue rounded" onClick={this.handleRetranslateClick.bind(this, i, currTranslation.language)}>
            Retranslate
          </span>
          <span className="btn btn-slim orange rounded" onClick={this.handleDeleteClick.bind(this, i, currTranslation.language)}>
            Delete
          </span>
        </td>
      </tr>
    );
  },
  render() {
    return (
      <div className="edition-details">
        {this.renderOriginalTextDisplay()}
        <div className="trail-edit-form">
          {this.renderSearchSelections()}
          {this.renderTableOrg(this.state.translations)}
          {this.renderButtonContainer()}
        </div>
      </div>
    );
  }
});

export { TranslationEditInterface };
